interface ServiceSectionProps {
  title: string;
  description: string;
  capabilities: string[];
  index: number;
}

export default function ServiceSection({ title, description, capabilities, index }: ServiceSectionProps) {
  const isEven = index % 2 === 0;
  const bgColor = isEven ? 'bg-white' : 'bg-gray-50';

  return (
    <section className={`${bgColor} py-24 px-6`}>
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-16 items-center`}>
          {/* Visual Panel */}
          <div className="flex-1 w-full">
            <div className="aspect-[4/3] bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl overflow-hidden relative">
              <div className="absolute inset-0 flex items-center justify-center p-12">
                <div className="grid grid-cols-2 gap-4 w-full">
                  {capabilities.map((capability, idx) => (
                    <div
                      key={idx}
                      className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 text-center shadow-sm"
                    >
                      <p className="text-sm font-medium text-gray-700">{capability}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Text Content */}
          <div className="flex-1">
            <h2 className="text-4xl md:text-5xl font-light tracking-tight text-gray-900 mb-6">
              {title}
            </h2>
            <p className="text-xl font-light text-gray-600 leading-relaxed">
              {description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}